import { TooltipProps as RadixTooltipProps, TooltipContentProps } from '@radix-ui/react-tooltip';
import { ReactNode } from 'react';

export enum UseMarkdownFor {
  none = 'none',
  title = 'title',
  detail = 'detail',
  both = 'both'
}

export interface TooltipProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> {
  title?: React.ReactNode;
  detail?: React.ReactNode;
  /** The element that show the tooltip. */
  children: React.ReactNode;
  hasCopy?: boolean;
  overlayClassName?: string;
  isMarkdown?: `${UseMarkdownFor}`;
  overlayStyle?: React.CSSProperties;
  visible?: RadixTooltipProps['open'];
  onVisibleChange?: RadixTooltipProps['onOpenChange'];
  placement?: TooltipContentProps['side'];
  placementOffset?: TooltipContentProps['sideOffset'];
  align?: TooltipContentProps['align'];
  alignOffset?: TooltipContentProps['alignOffset'];
  delay?: RadixTooltipProps['delayDuration'];
  disabled?: boolean;
  hideWhenDetached?: boolean;
  forceTooltipContentColor?: boolean;
  showArrow?: boolean;
  portalled?: boolean;
}

export type TooltipPropsType = string | ReactNode | Omit<TooltipProps, 'children'>;
